
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Router } from '@angular/router';

import { BehaviorSubject, Observable, Subject } from 'rxjs';

// JWT Module
import { JwtHelperService } from '@auth0/angular-jwt';

import { environment } from '../../../environments/environment';



// ----------------------------------------------------------------------------------------
// Auth Services is to used for
// > Logging In the User
// > Check If User is LoggedIn (return TRUE or FALSE)
// > Logout (Remove Token)
// > get User Token Info (UserID from the Token)
// > get Current Logged in User Object / Model
// Injected into the Auth Guard Service to check that the user is logged in on guarded
// routes in the Router
// 
// ----------------------------------------------------------------------------------------


@Injectable()
export class AuthService {

    private sessionStorageKey = 'userInfo';

    apiUrl = environment.apiUrl;

    // Other Components can Inject the User Service and Subscribe to the Observable
    private isLoggedInSubject = new BehaviorSubject<boolean>(false);
    // When Injecting the Service Components can subscribe to the isLoggedIn Observable
    // Then anytime in the App you Call the Auth.Service and 
    public isloggedIn$ = this.isLoggedInSubject.asObservable();


    // Other Components can Inject the Auth Service and Subscribe to the Observable
    private currentUserSubject = new BehaviorSubject<any>('');
    // Subscribe to the currentUser and get the logged in User
    public currentUser = this.currentUserSubject.asObservable();


    // Other Components can Inject the User Service and Subscribe to the Observable
    private showNavBarSubject = new BehaviorSubject<boolean>(true);
    // When Injecting the Service Components can subscribe to the isLoggedIn Observable
    // Then anytime in the App you Call the Auth.Service and 
    public showNavBar$: Observable<any> = this.showNavBarSubject;    



    jwtHelper = new JwtHelperService();

    constructor(private http: HttpClient,
                private router: Router) {}

    login(formParm): Observable<any> 
    {

        let url = `${ this.apiUrl }/api/v1/login`;

        return this.http.post(url, formParm).pipe(
        map((data: any) => {

            // console.log('User Data to be Used In Token : ', data.token);

            // Set the Local Storage with the Token Returned from the Server
            localStorage.setItem(this.sessionStorageKey, JSON.stringify(data.data));

            // Set the LoggedIn Flag
            this.updateLoginStatus(true);

            // Set the Current Logged in User Object
            // this.setCurrentUserInfo(data.json().data[0]);

            // Use the User Data info in the Token to Set the User Information
            this.getUserTokenInfo();

            return data;
        })); 

    }
  

    // ----------------------------------------------------------------- 
    // Get the Players Info need to be able to login
    // ----------------------------------------------------------------- 
    loginAuto(formParm): Observable<any> 
    {
        let url = `${ this.apiUrl }/api/v1/login-auto`;

        return this.http.post(url, formParm).pipe(
        map((data: any) => {

            console.log('User Data to be Used In Token : ', data.data[0]);

            // Set the Local Storage with the Token Returned from the Server
            localStorage.setItem('id_token', data.token);

            // Set the LoggedIn Flag
            this.checkLoginStatus();

            // Set the Current Logged in User Object
            // this.setCurrentUserInfo(data.json().data[0]);

            // Use the User Data info in the Token to Set the User Information
            this.getUserTokenInfo();

            return data;
        })); 

    }


    // ----------------------------------------------------------------- 
    // Get the Players Info need to be able to login
    // ----------------------------------------------------------------- 
    loginDeviceAuto(formParm): Observable<any> 
    {
        let url = `${ this.apiUrl }/api/v1/login-auto`;

        return this.http.post(url, formParm).pipe(
        map((data: any) => {

            console.log('User Data to be Used In Token : ', data.data[0]);

            // Set the Local Storage with the Token Returned from the Server
            localStorage.setItem('id_token', data.token);

            // Set the LoggedIn Flag
            this.checkLoginStatus();

            // Set the Current Logged in User Object
            // this.setCurrentUserInfo(data.json().data[0]);

            // Use the User Data info in the Token to Set the User Information
            this.getUserTokenInfo();

            return data;
        })); 

    }

    // ----------------------------------------------------------------- 
    //
    // ----------------------------------------------------------------- 
    forgotPassword(email): Observable<any> 
    {

        // let url =`http://localhost:5000/api/v1/forgot-password?email=${ email }`;
        let url = `${ this.apiUrl }/api/v1/forgot-password?email=${ email }`;

        return this.http.get(url).pipe(
        map((data: Response) => {

            console.log('Forgot Email in Auth Service : ', data);
            return data;
        })); 

    }


    // ----------------------------------------------------------------- 
    // Called on Login / Logout / Auth-guard
    // This is for components that are subscribing to the Observable
    // Show / Hide the Navbar / SideBar / etc
    // -----------------------------------------------------------------
    checkLoginStatus(): boolean 
    {
        const hasSession = this.hasSession();
        this.updateLoginStatus(hasSession);
        return hasSession;
    }
    
    private hasSession(): boolean 
    {
        // Get the session information from local storage
        const sessionInfo = localStorage.getItem(this.sessionStorageKey);
        
        // Check if session information is present
        const sessionExists = sessionInfo !== null;
    
        // Return true if session information exists, otherwise return false
        return sessionExists;
    }


    private updateLoginStatus(isLoggedIn: boolean): void 
    {
        this.isLoggedInSubject.next(isLoggedIn);
    }

    // -----------------------------------------------------------------
    // Log the User out of the App and Remove Token from localStorage
    // -----------------------------------------------------------------
    logout() 
    {
        // Remove the User Information from Local Storage
        localStorage.removeItem(this.sessionStorageKey);
        // Set the BehaviorSubject to False (Not Logged In)
        this.updateLoginStatus(false);
        // Redirect them to the login page
        this.router.navigate(['/login']);

        return false;

    }

    // ---------------------------------------------
    // Set Current Logged In User Object
    // Other Components can subscribe to the Auth Service
    // and get the User Object, 
    // this get updated on Login and User Profile Changes
    // ---------------------------------------------
    setCurrentUserInfo(user) {
        // console.log('-------- Set CurrentUserInfo User Object ------', user);
        // console.log('-------- Set CurrentUserInfo BehaviorSubject ------', this.currentUserSubject);
        this.currentUserSubject.next(user);
        
    }

    // -----------------------------------------------------------------
    // Get the User Token Info from localStorage and SET the Observable that 
    // components are subscribing to
    // Used to get the Logged In User and then use the ID to make API request
    // -----------------------------------------------------------------
    getUserTokenInfo(): any 
    {
        return JSON.parse(localStorage.getItem(this.sessionStorageKey));
    }



    // -----------------------------------------------------------------
    // HIDE the Navbar 
    // -----------------------------------------------------------------
    hideNavBar() 
    {

        this.showNavBarSubject.next(false);
    }

    // -----------------------------------------------------------------
    // SHOW the Navbar 
    // -----------------------------------------------------------------
    showNavBar() 
    {

        this.showNavBarSubject.next(true);
    }    

    getSessionToken(): string | null 
    {
        return localStorage.getItem(this.sessionStorageKey);
    }    

}
